import { isMobileDevice } from "../../utils/mobile";

export const signUpConfig = {
  hiddenDefaults: ["email", "phone_number"],
  signUpFields: [
    {
      key: "username",
      label: "Email",
      placeholder: "Email",
      required: true,
      displayOrder: 1
    },
    {
      key: "password",
      type: "password",
      label: "Password",
      placeholder: "Password",
      required: true,
      displayOrder: 2
    }
  ]
};

export default (theme = {}) => {
  const isMobile = isMobileDevice();
  const { darkMode, primary } = theme;

  return {
    signUpConfig,
    theme: {
      button: {
        borderRadius: 2,
        backgroundColor: darkMode ? "#535353" : primary
      },
      formSection: {
        border: isMobile
          ? "none"
          : `1px solid ${darkMode ? "#5E5E5E" : "#DCDCDC"}`,
        boxShadow: isMobile
          ? "none"
          : darkMode
          ? "1px 3px 5px rgba(0, 0, 0, 0.07)"
          : "1px 2px 3px rgba(0, 0, 0, 0.1)",
        color: "white",
        backgroundColor: isMobile
          ? "transparent"
          : darkMode
          ? "#343434"
          : "white"
      },
      inputLabel: {
        color: darkMode ? "white" : "black"
      },
      label: {
        color: darkMode ? "white" : "black"
      },
      sectionHeader: {
        color: darkMode ? "white" : "black"
      },
      input: {
        backgroundColor: darkMode ? "#343434" : "white",
        border: `1px solid ${darkMode ? "#5E5E5E" : "#DCDCDC"}`,
        color: darkMode ? "white" : "black"
      },
      hint: {
        color: darkMode ? "rgba(255,255,255,0.6)" : "#828282"
      },
      a: {
        color: darkMode ? "white" : primary
      }
    }
  };
};
